import * as actionTypes from "../actionTypes";

const initialState = {
    ecommerceCategoryData: [],
    ecommerceSubCategoryByCategoryIdData: [],
    ecommerceSubCategoryData: [],
    ecommerceAttributeData: [],
    ecommerceProductData: [],
};

const ecommerceReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_ECOMMERCE_CATEGORY: {
            return {
                ...state,
                ecommerceCategoryData: payload,
            };
        }
        case actionTypes.SET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID: {
            return {
                ...state,
                ecommerceSubCategoryByCategoryIdData: payload,
            };
        }
        case actionTypes.SET_ECOMMERCE_SUB_CATEGORY: {
            return {
                ...state,
                ecommerceSubCategoryData: payload,
            };
        }
        case actionTypes.SET_ECOMMERCE_ATTRIBUTE: {
            return {
                ...state,
                ecommerceAttributeData: payload,
            };
        }
        case actionTypes.SET_ECOMMERCE_PRODUCT: {
            return {
                ...state,
                ecommerceProductData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default ecommerceReducer;
